import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Box from '@mui/material/Box';
import { IconButton } from 'lead-list/components/IconButton';
import { FC } from 'react';

interface NavProps {
  title?: string;
  onBackClick?: () => void;
  onForwardClick?: () => void;
  disableForward?: boolean;
  disableBack?: boolean;
}

export const Nav: FC<NavProps> = ({ onBackClick, onForwardClick, disableBack, disableForward }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      sx={() => ({
        py: 4,
      })}
    >
      {!!onBackClick && (
        <IconButton
          ariaLabel="Go back"
          sx={(theme) => ({
            color: theme.palette.grey[500],
            mx: 1.5,
          })}
          onClick={onBackClick}
          disabled={disableBack}
        >
          <ArrowBackIcon />
        </IconButton>
      )}
      {!!onForwardClick && (
        <IconButton
          ariaLabel="Next"
          sx={(theme) => ({
            color: theme.palette.grey[500],
            mx: 1.5,
          })}
          onClick={onForwardClick}
          disabled={disableForward}
        >
          <ArrowForward />
        </IconButton>
      )}
    </Box>
  );
};
